const DEFAULT_NAMESPACE = 'common';

type GetNamespacesParams = {
  namespaces: string[];
};

export const getNamespaces = (params: GetNamespacesParams): string[] => {
  const { namespaces } = params;
  return [...namespaces, DEFAULT_NAMESPACE];
};
